module.exports = __webpack_public_path__ + "static/media/img.6669f7a3.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/img.jpg
 ** module id = 454
 ** module chunks = 0
 **/